//import { storageProvider } from '@ocean/configs'
const BANNER_NOTIFICATIONS_VIEWED = 'BANNER_NOTIFICATIONS_VIEWED'
function setCookie(name: string, value: string, days = 7) {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`
}

function getCookie(name: string): string | undefined {
  const nameEQ = `${name}=`
  const cookies = document.cookie.split(';')
  for (let c of cookies) {
    c = c.trim()
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length)
  }
  return undefined
}

function removeCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`
}
// BANNER Notifications for page refresh and direct links
class BannerNotificationsUtils {
  viewed = 'VIEWED'

  markBannerNotificationsViewed() {
    setCookie(BANNER_NOTIFICATIONS_VIEWED, this.viewed)
  }
  clearBannerNotificationsViewed() {
    removeCookie(BANNER_NOTIFICATIONS_VIEWED)
  }

  getBannerNotificationsState() {
    return getCookie(BANNER_NOTIFICATIONS_VIEWED)
  }
}

export default new BannerNotificationsUtils()
